import { PremiumOfferProvider } from '@src/pages/PremiumPage/PremiumOfferProvider';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter, StaticRouter } from 'react-router-dom';
import App from '@src/App';
import { BoxDomainBoundary } from '@src/routing/boxDomain';
import i18n from '@src/i18n';
import { store } from '@src/state/store';
import { ThemeProvider } from '@src/theme/ThemeProvider';
import type { Theme } from '@src/theme/theme';

import type { SeasonPackage } from '@src/theme/types';

export interface AppTreeProps {
  theme: Theme;
  seasonPackage: SeasonPackage;
  /** Set during SSR so the static HTML is the page for that path. */
  url?: string;
}

/** Same tree SSR renderToString and the client hydrateRoot attach to. */
export function AppTree({ theme, seasonPackage, url }: AppTreeProps) {
  const app = (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <ThemeProvider initialTheme={theme} initialSeasonPackage={seasonPackage}>
          <PremiumOfferProvider><App /></PremiumOfferProvider>
        </ThemeProvider>
      </Provider>
    </I18nextProvider>
  );

  if (url != null) {
    return <StaticRouter location={url}>{app}</StaticRouter>;
  }

  return (
    <BrowserRouter>
      <BoxDomainBoundary>{app}</BoxDomainBoundary>
    </BrowserRouter>
  );
}
